export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1646_.730432b8.jpg";